<template>
  <div class="audiology-kpis__filter--compare">
    <span class="audiology-kpis__filter--label">COMPARISONS:</span>
    <span v-on:click="changeCompMode('number')" class="glyphicon glyphicon-usd circleBtn compNumber"></span>
    <span v-on:click="changeCompMode('percent')" class="circleBtn compPercent">%</span>
  </div>
</template>

<script>
  export default {
    name: 'Comparisons',
    methods: {
      changeCompMode(mode) {
        this.$store.dispatch('allergyKpis/setProperty', { key: 'compMode', value: mode });
      },
    },
  };
</script>
